// // @ts-nocheck
// import React, { useState, useEffect, useCallback } from 'react'
// import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react'
// import { Link, useNavigate } from 'react-router-dom';
// import { Toaster, toast } from 'sonner';
// import { UserDetails } from '../../auth/authTypes';
// import { useAppDispatch } from '../../../app/hooks';
// import { fetchLocationListStatus, fetchScoreCardList, updateLocation, createLocation } from '../../scorecard/scoreCardSlice';
// import Badge from '../../../components/common/Badge';
// import DropDown from '../../../components/common/DropDown';
// import CreateScoreCard from './CreateScoreCard';
// import { createTeamsPayload } from '../../scorecard/scoreCardTypes';
// import TooltipButton from '../../../components/common/TooltipButton';
// import { ExclamationIcon, ThreeDotIcon } from '../../../components/icons';


// type ChannelProps = {
//   userDetails: UserDetails | null;
// }

// function classNames(...classes: any) {
//   return classes.filter(Boolean).join(' ')
// }

// const roleSearchList = [{ name: "active" }, { name: "deleted" },
// { name: "archived" }]




// const ScoreCard: React.FC<ChannelProps> = React.memo(({ }) => {
//   const baseIdString = localStorage.getItem('UserBaseId') || localStorage.getItem('createBaseId');
//   const baseId = baseIdString ? JSON.parse(baseIdString) : null;
//   const [searchVal, setSearchVal] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editBoardData, setEditBoardData] = useState<{ id: number; baseId: number } | null>(null);
//   const [boardsFetched, setBoardsFetched] = useState<any[]>([]);
//   const dispatch = useAppDispatch();
//   const [dataLoading, setDataLoading] = useState(false);
//   const [selectSearchRole, setSelectSearchRole] = useState("active")
//   const [loading, setLoading] = useState(false)
//   const [loading1, setLoading1] = useState(false)
//   const navigate = useNavigate();
//   const [assignUser, setAssignUser] = useState('')
//   const [assignUserList, setAssignUserList] = useState<{ id: number, name: string }[]>([]);
//   const [showUserList, setShowUserList] = useState(false);
//   const [openUserListIds, setOpenUserListIds] = useState<number[]>([]);



//   // Add this useEffect to populate assignUserList from localStorage
//   useEffect(() => {
//     const baseMembersDetailsString = localStorage.getItem('baseMembersDetails');
//     if (baseMembersDetailsString) {
//       const baseMembersDetails = JSON.parse(baseMembersDetailsString);
//       const members = baseMembersDetails.data?.baseMembers || [];

//       // Transform members to the required format
//       const userList = members.map((member: any) => ({
//         id: member.id,
//         name: member.name
//       }));

//       setAssignUserList(userList);
//     }
//   }, []);



//   // In Teams component
//   useEffect(() => {
//     const teamInfoString = localStorage.getItem('baseScoreCardData');
//     if (teamInfoString) {
//       const teamInfo = JSON.parse(teamInfoString);
//       setBoardsFetched(teamInfo.data);
//       setDataLoading(false);
//     } else {
//       const fetchTeams = async () => {
//         setDataLoading(true);
//         try {
//           const baseResponse = await dispatch(fetchScoreCardList(baseId));

//           if (baseResponse?.payload) {
//             setBoardsFetched(baseResponse.payload.data);
//             localStorage.setItem('baseScoreCardData', JSON.stringify(baseResponse.payload));
//           } else {
//             setBoardsFetched([]);
//           }
//         } catch (error) {
//           console.error("Error fetching teams:", error);
//           setBoardsFetched([]);
//         } finally {
//           setDataLoading(false);
//         }
//       };

//       if (baseId) {
//         fetchTeams();
//       }
//     }
//   }, [baseId, dispatch]);


//   const handleDeleteBoard = useCallback(async (id: number, baseId: number) => {
//     const payload: createTeamsPayload = {
//       status: 'deleted',
//       id: id
//     };

//     try {
//       // Update existing team
//       const response = await dispatch(updateLocation({
//         payload,
//         userId: baseId,
//         id: id
//       }));

//       if (response?.payload) {
//         toast.success(response?.payload?.message || 'Status has been updated successfully');
//         // Update the local storage and state
//         const updatedBoards = boardsFetched.map(board =>
//           board.id === id ? { ...board, status: 'deleted' } : board
//         );

//         localStorage.setItem('baseScoreCardData', JSON.stringify({ data: updatedBoards }));

//         setBoardsFetched(updatedBoards);

//         setIsModalOpen(false);
//         setEditBoardData(null);
//       } else {
//         toast.error('Failed to update status');
//       }
//     } catch (error) {
//       toast.error('An error occurred while updating the status');
//       console.error(error);
//     }
//   }, [boardsFetched, dispatch]);

//   const handleArchivedBoard = useCallback(async (id: number, baseId: number) => {
//     const payload: createTeamsPayload = {
//       status: 'archived',
//       id: id
//     };

//     try {
//       // Update existing team
//       const response = await dispatch(updateLocation({
//         payload,
//         userId: baseId,
//         id: id
//       }));

//       if (response?.payload) {
//         toast.success(response?.payload?.message || 'Status has been updated successfully');
//         // Update the local storage and state
//         const updatedBoards = boardsFetched.map(board =>
//           board.id === id ? { ...board, status: 'archived' } : board
//         );

//         localStorage.setItem('baseScoreCardData', JSON.stringify({ data: updatedBoards }));

//         setBoardsFetched(updatedBoards);

//         setIsModalOpen(false);
//         setEditBoardData(null);
//       } else {
//         toast.error('Failed to update status');
//       }
//     } catch (error) {
//       toast.error('An error occurred while updating the status');
//       console.error(error);
//     }
//   }, [boardsFetched, dispatch]);

//   // Add a new useEffect to handle updates from localStorage
//   useEffect(() => {
//     const handleStorageChange = (e: StorageEvent) => {
//       if (e.key === 'baseScoreCardData' && e.newValue) {
//         const teamsDataArray = JSON.parse(e.newValue);
//         setBoardsFetched(teamsDataArray.data || []);
//       }
//     };

//     window.addEventListener('storage', handleStorageChange);
//     return () => window.removeEventListener('storage', handleStorageChange);
//   }, []);


//   const handleEdit = useCallback((id: number, baseId: number) => {
//     const teamToEdit = boardsFetched.find(team => team.id === id);
//     if (teamToEdit) {
//       setEditBoardData(teamToEdit);
//       setIsModalOpen(true);
//     }
//   }, [boardsFetched]);

//   const openModal = () => {
//     setEditBoardData(null);  // Add this line
//     setIsModalOpen(true);
//   };

//   const handleTeamsData = (id: any) => {
//     navigate(`/${baseId}/settings/scorecard/${id}`);
//   }

//   const handleSearchRoleChange = (role: string) => {
//     setSelectSearchRole(role)
//   }

//   const handleActive = async () => {
//     setLoading1(true);
//     try {
//       const res = await dispatch(fetchLocationListStatus({ baseId, status: 'active' }));
//       if (res.payload) {
//         setBoardsFetched(res.payload.data);
//         localStorage.setItem('baseScoreCardData', JSON.stringify(res.payload));
//       } else {
//         console.error('No payload received');
//       }
//     } catch (error) {
//       console.error('Delete failed:', error);
//       alert('Failed to delete location data. Please try again later.');
//     } finally {
//       setLoading1(false);
//     }
//   };


//   const handleDelete = async () => {
//     setLoading1(true);
//     try {
//       const res = await dispatch(fetchLocationListStatus({ baseId, status: 'deleted' }));
//       if (res.payload) {
//         setBoardsFetched(res.payload.data);
//         localStorage.setItem('baseScoreCardData', JSON.stringify(res.payload));
//       } else {
//         console.error('No payload received');
//       }
//     } catch (error) {
//       console.error('Delete failed:', error);
//       alert('Failed to delete location data. Please try again later.');
//     } finally {
//       setLoading1(false);
//     }
//   };


//   const handleSuspend = async () => {
//     setLoading(true)
//     try {
//       const res = await dispatch(fetchLocationListStatus({ baseId, status: 'archived' }));
//       if (res.payload) {
//         setBoardsFetched(res.payload.data)
//         // Update local storage
//         localStorage.setItem('baseScoreCardData', JSON.stringify(res.payload));
//       } else {
//         console.error('No payload received');
//       }
//     } catch (error) {
//       console.error('Suspend failed:', error);
//     } finally {
//       setLoading(false)
//     }
//   };

//   // const handleAssignSelect = (user, id) => {
//   //   setBoardsFetched(prevBoards => 
//   //     prevBoards.map(board => 
//   //       board.id === id ? { ...board, assignedUser: user.name } : board
//   //     )
//   //   );
//   //   setOpenUserListIds(prev => prev.filter(openId => openId !== id));
//   // };

//   const handleAssignSelect = async (user, id) => {
//     const boardToUpdate = boardsFetched.find(board => board.id === id);

//     const payload = {
//       assigned_to: user.id, // Assuming user.id is the correct field for the API
//       // Include other necessary fields for the payload
//     };

//     if (boardToUpdate.assignedUser) {
//       // Update existing location
//       const response = await dispatch(updateLocation({
//         payload,
//         userId: baseId,
//         id: boardToUpdate.id
//       }));

//       if (response.meta.requestStatus === 'fulfilled') {
//         setOpenUserListIds(
//           prev => prev.filter(openId => openId !== id)
//         )
//         const baseResponse = await dispatch(fetchScoreCardList(baseId));

//         if (baseResponse?.payload) {
//           setBoardsFetched(baseResponse.payload.data);
//           localStorage.setItem('baseScoreCardData', JSON.stringify(baseResponse.payload));
//           setOpenUserListIds(prev => prev.filter(openId => openId !== id));
//         }
//         toast.success('User assigned successfully!');

//         setBoardsFetched(prevBoards =>
//           prevBoards.map(board =>
//             board.id === id ? { ...board, assignedUser: user.name } : board
//           )
//         );
//       } else {
//         toast.error('Failed to assign user.');
//       }
//     } else {
//       // Create new location
//       const response = await dispatch(updateLocation({ payload, userId: baseId, id: boardToUpdate.id }));
//       if (response.meta.requestStatus === 'fulfilled') {
//         setOpenUserListIds(
//           prev => prev.filter(openId => openId !== id)
//         )
//         const baseResponse = await dispatch(fetchScoreCardList(baseId));

//         if (baseResponse?.payload) {
//           setBoardsFetched(baseResponse.payload.data);
//           localStorage.setItem('baseScoreCardData', JSON.stringify(baseResponse.payload));
//           setOpenUserListIds(prev => prev.filter(openId => openId !== id));
//         }
//         toast.success('User assigned successfully!');
//         setBoardsFetched(prevBoards =>
//           prevBoards.map(board =>
//             board.id === id ? { ...board, assignedUser: user.name } : board
//           )
//         );
//       } else {
//         toast.error('Failed to assign user.');
//       }
//     }


//     setOpenUserListIds(
//       prev => prev.filter(openId => openId !== id)
//     )
//   };

//   const toggleUserList = (id: number) => {
//     setOpenUserListIds(prev =>
//       prev.includes(id)
//         ? prev.filter(openId => openId !== id)
//         : [...prev, id]
//     );
//   };
//   return (
//     <>
//       <Toaster richColors />

//       <div className='h-full'>

//         <main className='py-[34px] lg:py-[70px] px-0 lg:px-10 h-full flex'>
//           <div className='px-[2px] sm:px-6 lg:px-8 w-full flex justify-center'>
//             <div className='w-full max-w-[640px]'>
//               <div className='flex flex-col gap-y-[6px]'>
//                 <h2 className='text-[20px] lg:text-[24px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem]'>Base Scorecard</h2>
//                 <p className='text-sm leading-6 text-[#5c5c5e] font-medium'>
//                   Base Scorecard Description
//                 </p>
//               </div>


//               <div className=' mt-6 lg:mt-10 flex items-center  w-full gap-x-3'>

//                 <div className='w-full lg:w-[40%]'>
//                   <label htmlFor='searchEmail' className='wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5'>
//                     Scorecard
//                   </label>
//                   <div className='mt-[6px]'>
//                     <input
//                       type="text"
//                       value={searchVal}
//                       onChange={(e) => setSearchVal(e.target.value)}
//                       name="search"
//                       id="search"
//                       placeholder='Search name and email'
//                       className="flex w-full grow border px-4 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600
//                       focus:outline focus:outline-2 focus:-outline-offset-2 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
//                       border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
//                     />
//                   </div>
//                 </div>

//                 <div className='w-full lg:w-[20%]'>
//                   <div className='mt-[32px]'>
//                     <DropDown
//                       onChangeValue={handleSearchRoleChange}
//                       data={roleSearchList}
//                       previousValue={selectSearchRole}
//                       onDelete={handleDelete}
//                       onArchived={handleSuspend}
//                       onActive={handleActive}
//                     />
//                     {/* <DropDown onChangeValue={(value) => setSelectSearchRole(value)} data={roleSearchList} previousValue={selectSearchRole} /> */}

//                   </div>
//                 </div>
//                 <div className='w-full lg:w-[40%]'>
//                   <div className='mt-[32px] flex justify-end'>
//                     <button
//                       onClick={openModal}
//                       type='button'
//                       className=" inline-flex shrink-0  justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
//                     >
//                       Create Scorecard
//                     </button>
//                   </div>
//                 </div>

//               </div>
//               <div className='mt-6 w-full'>
//                 {dataLoading ? (
//                   <div className="flex items-center justify-center relative z-50" style={{ height: 'calc(100vh - 191px)' }}>
//                     <div className="simple-spinner-loader">
//                       <span></span>
//                     </div>
//                   </div>
//                 ) : boardsFetched.length === 0 ? (
//                   <div className='w-full mt-5 flex h-[300px] justify-center items-center flex-col gap-y-3'>
//                     <ExclamationIcon />
//                     <p className='text-[#0000007a] text-[13px]'>No results found</p>
//                   </div>
//                 ) : (
//                   <>
//                     {boardsFetched?.filter((post) => {
//                       if (searchVal === "") {
//                         return post;
//                       } else if (
//                         post?.scorecard_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
//                         post?.scorecard_description?.toLowerCase().includes(searchVal.toLowerCase())
//                       ) {
//                         return post;
//                       }
//                     })
//                       .map((items: any, index: number) => {
//                       let findUser = 
//                       items?.assigned_to &&
//                       assignUserList.find((user) => user.id === items.assigned_to);



//                         // const findUSer = 
//                         //   items?.assigned_to &&
//                         //   items?.find((user) => user.id === items.assigned_to);


//                         return (
//                           <div key={index} className='w-full flex border-b border-light-gray-200'>
//                             <ul className='list-none w-full'>
//                               <li className='flex flex-row items-center justify-between text-[0.875rem] px-[0rem] py-4 w-full'>
//                                 <div className='flex shrink-0 pr-0' onClick={() => handleTeamsData(items?.id)}>
//                                   <span
//                                     className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white capitalize"
//                                     style={{ backgroundColor: items?.scorecard_colour }}
//                                   >
//                                     {items.scorecard_name[0]}
//                                   </span>
//                                 </div>
//                                 <div className='flex-1 px-4'>
//                                   <div className='flex justify-start items-center gap-x-2'>
//                                     <p className='text-[0.8125rem] font-medium leading-5 text-[#1b1b1b] capitalize' onClick={() => handleTeamsData(items?.id)}>{items.scorecard_name}</p>
//                                     {
//                                       items.ai_check === 'yes' &&
//                                       <span onClick={() => handleTeamsData(items?.id)} className="inline-flex capitalize items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
//                                         ai assist
//                                       </span>
//                                     }
//                                     <div className="relative">
//                                       <button
//                                         type="button"
//                                         onClick={() => toggleUserList(items.id)}
//                                         className="table-tooltip flex items-center max-w-fit font-[500] leading-[1.2]"
//                                       >
//                                         {findUser ? (
//                                           <span className="inline-flex capitalize items-center h-[24px] rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 border-dashed border border-gray-500">
//                                             {findUser.name} 
//                                           </span>
//                                         ) : (
//                                           <span className="inline-flex capitalize items-center h-[24px] rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 border-dashed border border-gray-500">
//                                             Assign User
//                                           </span>
//                                         )}
//                                       </button>
//                                       {openUserListIds.includes(items.id) && (
//                                         <div className="absolute z-10 mt-[9px] left-[-16px] bg-white max-w-[191.05px] min-w-[191.05px] w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
//                                           <div className="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
//                                             <div className='max-h-[200px] overflow-auto'>
//                                               {assignUserList.length > 0 ? (
//                                                 assignUserList.map((user, index) => (
//                                                   <a
//                                                     key={index}
//                                                     href="#"
//                                                     className="block px-2 py-1.5 hover:bg-gray-200 text-[#1d2025] hover:text-gray-900 rounded-md"
//                                                     onClick={() => handleAssignSelect(user, items.id)}
//                                                   >
//                                                     <div className="flex items-center gap-2">
//                                                       <span className="font-normal block truncate">
//                                                         {user.name} {/* Render the name property */}
//                                                       </span>
//                                                     </div>
//                                                   </a>
//                                                 ))
//                                               ) : (
//                                                 <p className="text-gray-500 text-center py-2">No users found</p>
//                                               )}
//                                             </div>
//                                           </div>
//                                         </div>
//                                       )}
//                                     </div>
//                                   </div>
//                                   <p className='text-[0.8125rem] font-normal leading-4 text-[#5c5c5e]'>{items?.scorecard_description}</p>
//                                 </div>
//                                 <div>
//                                   <Badge status={items?.status} />


//                                 </div>
//                                 <div className='px-2 flex items-center'>
//                                   <Menu as="div" className="relative inline-block text-left">
//                                     <div>
//                                       <MenuButton className="rounded-md flex items-center justify-center hover:bg-light-gray-200 focus:bg-light-gray-200 w-[32px] h-[32px]">
//                                         <span className="sr-only">Open options</span>
//                                         <ThreeDotIcon />
//                                       </MenuButton>
//                                     </div>

//                                     <Transition
//                                       enter="transition ease-out duration-100"
//                                       enterFrom="transform opacity-0 scale-95"
//                                       enterTo="transform opacity-100 scale-100"
//                                       leave="transition ease-in duration-75"
//                                       leaveFrom="transform opacity-100 scale-100"
//                                       leaveTo="transform opacity-0 scale-95"
//                                     >
//                                       <MenuItems className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
//                                         <div className="py-1">
//                                           <MenuItem>
//                                             {({ focus }) => (
//                                               <div
//                                                 onClick={() => handleEdit(items.id, items.base_id)}
//                                                 className={classNames(
//                                                   focus ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
//                                                   'block px-4 py-2 text-sm'
//                                                 )}
//                                               >
//                                                 Edit
//                                               </div>
//                                             )}
//                                           </MenuItem>
//                                           <MenuItem>
//                                             {({ focus }) => (
//                                               <Link
//                                                 to="#"
//                                                 className={classNames(
//                                                   focus ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
//                                                   'block px-4 py-2 text-sm'
//                                                 )}
//                                                 onClick={() => handleDeleteBoard(items.id, items.base_id)}
//                                               >
//                                                 Delete
//                                               </Link>
//                                             )}
//                                           </MenuItem>
//                                           <MenuItem>
//                                             {({ focus }) => (
//                                               <Link
//                                                 to="#"
//                                                 onClick={() => handleArchivedBoard(items.id, items.base_id)}
//                                                 className={classNames(
//                                                   focus ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
//                                                   'block px-4 py-2 text-sm'
//                                                 )}
//                                               >
//                                                 Archived
//                                               </Link>
//                                             )}
//                                           </MenuItem>

//                                         </div>
//                                       </MenuItems>
//                                     </Transition>
//                                   </Menu>
//                                 </div>
//                               </li>
//                             </ul>
//                           </div>
//                         );
//                       })}
//                   </>
//                 )}
//               </div>

//             </div>
//           </div>
//         </main>
//       </div>

//       <CreateScoreCard
//         isModalOpen={isModalOpen}
//         setIsModalOpen={setIsModalOpen}
//         editBoardData={editBoardData}
//         baseId={baseId}
//         setEditBoardData={setEditBoardData}
//       />
//     </>
//   )
// });
// export default ScoreCard


// @ts-nocheck
import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react'
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react'
import { Link, useNavigate } from 'react-router-dom';
import { Toaster, toast } from 'sonner';
import { UserDetails } from '../../auth/authTypes';
import { useAppDispatch } from '../../../app/hooks';
import { fetchLocationListStatus, fetchScoreCardList, updateLocation, createLocation } from '../../scorecard/scoreCardSlice';
import Badge from '../../../components/common/Badge';
import DropDown from '../../../components/common/DropDown';
import CreateScoreCard from './CreateScoreCard';
import { createTeamsPayload } from '../../scorecard/scoreCardTypes';
import TooltipButton from '../../../components/common/TooltipButton';
import { ExclamationIcon, ThreeDotIcon } from '../../../components/icons';


type ChannelProps = {
  userDetails: UserDetails | null;
}

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}

const roleSearchList = [{ name: "active" }, { name: "deleted" },
{ name: "archived" }]


const useClickOutside = (handler) => {
  const ref = useRef(null);

  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);

  return ref;
};

const UserAssignmentDropdown = ({
  assignUserList,
  onUserSelect,
  currentlyAssignedUser
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const dropdownRef = useClickOutside(() => {
    setIsDropdownOpen(false);
    setSearchTerm('');
  });

  // Memoized filtered users based on search term
  const filteredUsers = useMemo(() => {
    return assignUserList.filter(user =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [assignUserList, searchTerm]);

  const handleUserSelect = (user) => {
    onUserSelect(user);
    setIsDropdownOpen(false);
    setSearchTerm('');
  };

  const toggleDropdown = (e) => {
    // Prevent event from propagating to document
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };


  return (
    <div ref={dropdownRef} className="relative">
      <button
        // onClick={toggleDropdown}
        className="inline-flex items-center h-[24px] rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 border-dashed border border-gray-500"
      >
        {currentlyAssignedUser || 'Assign User'}

      </button>

      {isDropdownOpen && (
        <div className="absolute z-10 mt-[9px] left-[-16px] bg-white max-w-[191.05px] min-w-[191.05px] w-full overflow-hidden rounded-lg border border-border bg-popover py-1 px-0 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
          <div className="p-1 border-b">
            <input
              type="text"
              placeholder="Search users..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-2 py-1 border rounded text-sm focus:outline-none focus:ring-0 focus:ring-blue-500 border-none outline-none"
            />
          </div>
          <ul className="max-h-60 overflow-y-auto p-1">
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user) => (
                <li
                  key={user.id}
                  onClick={() => handleUserSelect(user)}
                  className="px-3 py-1.5 hover:bg-gray-100 cursor-pointer text-sm rounded-md"
                >
                  {user.name}
                </li>
              ))
            ) : (
              <li className="px-3 py-2 text-gray-500 text-sm">
                No users found
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};



const ScoreCard: React.FC<ChannelProps> = React.memo(({ }) => {
  const baseIdString = localStorage.getItem('UserBaseId') || localStorage.getItem('createBaseId');
  const baseId = baseIdString ? JSON.parse(baseIdString) : null;
  const [searchVal, setSearchVal] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editBoardData, setEditBoardData] = useState<{ id: number; baseId: number } | null>(null);
  const [boardsFetched, setBoardsFetched] = useState<any[]>([]);
  const dispatch = useAppDispatch();
  const [dataLoading, setDataLoading] = useState(false);
  const [selectSearchRole, setSelectSearchRole] = useState("active")
  const [loading, setLoading] = useState(false)
  const [loading1, setLoading1] = useState(false)
  const navigate = useNavigate();
  const [assignUser, setAssignUser] = useState('')
  const [assignUserList, setAssignUserList] = useState<{ id: number, name: string }[]>([]);
  const [showUserList, setShowUserList] = useState(false);
  const [openUserListIds, setOpenUserListIds] = useState<number[]>([]);



  // Add this useEffect to populate assignUserList from localStorage
  useEffect(() => {
     const userDetailsData = localStorage.getItem('jobByHiringTeamMembers');

    if (userDetailsData) {
      const members = userDetailsData ? JSON.parse(userDetailsData) : [];
      // Transform members to the required format
      const userList = members.map((member: any) => ({
        id: member.id,
        name: member.name
      }));

      setAssignUserList(userList);
    }
  }, []);



  // In Teams component
  useEffect(() => {
    const teamInfoString = localStorage.getItem('baseScoreCardData');
    if (teamInfoString) {
      const teamInfo = JSON.parse(teamInfoString);
      setBoardsFetched(teamInfo.data);
      setDataLoading(false);
    } else {
      const fetchTeams = async () => {
        setDataLoading(true);
        try {
          const baseResponse = await dispatch(fetchScoreCardList(baseId));

          if (baseResponse?.payload) {
            setBoardsFetched(baseResponse.payload.data);
            localStorage.setItem('baseScoreCardData', JSON.stringify(baseResponse.payload));
          } else {
            setBoardsFetched([]);
          }
        } catch (error) {
          console.error("Error fetching teams:", error);
          setBoardsFetched([]);
        } finally {
          setDataLoading(false);
        }
      };

      if (baseId) {
        fetchTeams();
      }
    }
  }, [baseId, dispatch]);


  const handleDeleteBoard = useCallback(async (id: number, baseId: number) => {
    const payload: createTeamsPayload = {
      status: 'deleted',
      id: id
    };

    try {
      // Update existing team
      const response = await dispatch(updateLocation({
        payload,
        userId: baseId,
        id: id
      }));

      if (response?.payload) {
        toast.success(response?.payload?.message || 'Status has been updated successfully');
        // Update the local storage and state
        const updatedBoards = boardsFetched.map(board =>
          board.id === id ? { ...board, status: 'deleted' } : board
        );

        localStorage.setItem('baseScoreCardData', JSON.stringify({ data: updatedBoards }));

        setBoardsFetched(updatedBoards);

        setIsModalOpen(false);
        setEditBoardData(null);
      } else {
        toast.error('Failed to update status');
      }
    } catch (error) {
      toast.error('An error occurred while updating the status');
      console.error(error);
    }
  }, [boardsFetched, dispatch]);

  const handleArchivedBoard = useCallback(async (id: number, baseId: number) => {
    const payload: createTeamsPayload = {
      status: 'archived',
      id: id
    };

    try {
      // Update existing team
      const response = await dispatch(updateLocation({
        payload,
        userId: baseId,
        id: id
      }));

      if (response?.payload) {
        toast.success(response?.payload?.message || 'Status has been updated successfully');
        // Update the local storage and state
        const updatedBoards = boardsFetched.map(board =>
          board.id === id ? { ...board, status: 'archived' } : board
        );

        localStorage.setItem('baseScoreCardData', JSON.stringify({ data: updatedBoards }));

        setBoardsFetched(updatedBoards);

        setIsModalOpen(false);
        setEditBoardData(null);
      } else {
        toast.error('Failed to update status');
      }
    } catch (error) {
      toast.error('An error occurred while updating the status');
      console.error(error);
    }
  }, [boardsFetched, dispatch]);

  // Add a new useEffect to handle updates from localStorage
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'baseScoreCardData' && e.newValue) {
        const teamsDataArray = JSON.parse(e.newValue);
        setBoardsFetched(teamsDataArray.data || []);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);


  const handleEdit = useCallback((id: number, baseId: number) => {
    const teamToEdit = boardsFetched.find(team => team.id === id);
    if (teamToEdit) {
      setEditBoardData(teamToEdit);
      setIsModalOpen(true);
    }
  }, [boardsFetched]);

  const openModal = () => {
    setEditBoardData(null);  // Add this line
    setIsModalOpen(true);
  };

  const handleTeamsData = (id: any) => {
    navigate(`/${baseId}/settings/scorecard/${id}`);
  }

  const handleSearchRoleChange = (role: string) => {
    setSelectSearchRole(role)
  }

  const handleActive = async () => {
    setLoading1(true);
    try {
      const res = await dispatch(fetchLocationListStatus({ baseId, status: 'active' }));
      if (res.payload) {
        setBoardsFetched(res.payload.data);
        localStorage.setItem('baseScoreCardData', JSON.stringify(res.payload));
      } else {
        console.error('No payload received');
      }
    } catch (error) {
      console.error('Delete failed:', error);
      alert('Failed to delete location data. Please try again later.');
    } finally {
      setLoading1(false);
    }
  };


  const handleDelete = async () => {
    setLoading1(true);
    try {
      const res = await dispatch(fetchLocationListStatus({ baseId, status: 'deleted' }));
      if (res.payload) {
        setBoardsFetched(res.payload.data);
        localStorage.setItem('baseScoreCardData', JSON.stringify(res.payload));
      } else {
        console.error('No payload received');
      }
    } catch (error) {
      console.error('Delete failed:', error);
      alert('Failed to delete location data. Please try again later.');
    } finally {
      setLoading1(false);
    }
  };


  const handleSuspend = async () => {
    setLoading(true)
    try {
      const res = await dispatch(fetchLocationListStatus({ baseId, status: 'archived' }));
      if (res.payload) {
        setBoardsFetched(res.payload.data)
        // Update local storage
        localStorage.setItem('baseScoreCardData', JSON.stringify(res.payload));
      } else {
        console.error('No payload received');
      }
    } catch (error) {
      console.error('Suspend failed:', error);
    } finally {
      setLoading(false)
    }
  };

  // const handleAssignSelect = (user, id) => {
  //   setBoardsFetched(prevBoards => 
  //     prevBoards.map(board => 
  //       board.id === id ? { ...board, assignedUser: user.name } : board
  //     )
  //   );
  //   setOpenUserListIds(prev => prev.filter(openId => openId !== id));
  // };

  const handleAssignSelect = async (user, id) => {
    const boardToUpdate = boardsFetched.find(board => board.id === id);

    const payload = {
      assigned_to: user.id, // Assuming user.id is the correct field for the API
      // Include other necessary fields for the payload
    };

    if (boardToUpdate.assignedUser) {
      // Update existing location
      const response = await dispatch(updateLocation({
        payload,
        userId: baseId,
        id: boardToUpdate.id
      }));

      if (response.meta.requestStatus === 'fulfilled') {
        setOpenUserListIds(
          prev => prev.filter(openId => openId !== id)
        )
        const baseResponse = await dispatch(fetchScoreCardList(baseId));

        if (baseResponse?.payload) {
          setBoardsFetched(baseResponse.payload.data);
          localStorage.setItem('baseScoreCardData', JSON.stringify(baseResponse.payload));
          setOpenUserListIds(prev => prev.filter(openId => openId !== id));
        }
        toast.success('User assigned successfully!');

        setBoardsFetched(prevBoards =>
          prevBoards.map(board =>
            board.id === id ? { ...board, assignedUser: user.name } : board
          )
        );
      } else {
        toast.error('Failed to assign user.');
      }
    } else {
      // Create new location
      const response = await dispatch(updateLocation({ payload, userId: baseId, id: boardToUpdate.id }));
      if (response.meta.requestStatus === 'fulfilled') {
        setOpenUserListIds(
          prev => prev.filter(openId => openId !== id)
        )
        const baseResponse = await dispatch(fetchScoreCardList(baseId));

        if (baseResponse?.payload) {
          setBoardsFetched(baseResponse.payload.data);
          localStorage.setItem('baseScoreCardData', JSON.stringify(baseResponse.payload));
          setOpenUserListIds(prev => prev.filter(openId => openId !== id));
        }
        toast.success('User assigned successfully!');
        setBoardsFetched(prevBoards =>
          prevBoards.map(board =>
            board.id === id ? { ...board, assignedUser: user.name } : board
          )
        );
      } else {
        toast.error('Failed to assign user.');
      }
    }


    setOpenUserListIds(
      prev => prev.filter(openId => openId !== id)
    )
  };

  const toggleUserList = (id: number) => {
    setOpenUserListIds(prev =>
      prev.includes(id)
        ? prev.filter(openId => openId !== id)
        : [...prev, id]
    );
  };
  return (
    <>
      <Toaster richColors />

      <div className='h-full'>

        <main className='py-[34px] lg:py-[70px] px-0 lg:px-10 h-full flex'>
          <div className='px-[2px] sm:px-6 lg:px-8 w-full flex justify-center'>
            <div className='w-full max-w-[640px]'>
              <div className='flex flex-col gap-y-1 w-full'>
                <h2 className='text-[20px] lg:text-[24px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem]'>
                 Candidate Scorecards
                </h2>
                <p className='text-sm leading-5 text-[#5c5c5e] font-medium'>
                Create structured scorecards to evaluate candidates consistently. Make data-driven hiring decisions and reduce bias.
                </p>
              </div>

              <div className='bg-[#e0e0e0] w-full h-[1px] my-8'></div>

              <div className=' mt-6 lg:mt-8 flex items-center  w-full gap-x-3'>

                <div className='w-full lg:w-[40%]'>
                  {/* <label htmlFor='searchEmail' className='wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5'>
                    Scorecard
                  </label> */}
                  <div className='mt-[0px]'>
                    <input
                      type="text"
                      value={searchVal}
                      onChange={(e) => setSearchVal(e.target.value)}
                      name="search"
                      id="search"
                      placeholder='Search name and email'
                      className="flex w-full grow border px-4 pt-2 pb-[10px] text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600
                      focus:outline focus:outline-2 focus:-outline-offset-1 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
                           border-[#e7e7e8] dark:border-surface-100 focus:outline-indigo-600 h-[34px] rounded-[0.375rem]"
                    />
                  </div>
                </div>

                <div className='w-full lg:w-[20%]'>
                  <div className='mt-[0px]'>
                    <DropDown
                      onChangeValue={handleSearchRoleChange}
                      data={roleSearchList}
                      previousValue={selectSearchRole}
                      onDelete={handleDelete}
                      onArchived={handleSuspend}
                      onActive={handleActive}
                    />
                    {/* <DropDown onChangeValue={(value) => setSelectSearchRole(value)} data={roleSearchList} previousValue={selectSearchRole} /> */}

                  </div>
                </div>
                <div className='w-full lg:w-[40%]'>
                  <div className='mt-[0px] flex justify-end'>
                    <button
                      onClick={openModal}
                      type='button'
                      className=" inline-flex shrink-0  justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Create Scorecard
                    </button>
                  </div>
                </div>

              </div>
              <div className='mt-6 pb-10 w-full'>
              <div className="bg-white rounded-lg border border-solid border-[#0009321f]">
              <div className="font-semibold text-[#1c2024] text-sm  px-[11.4px] py-[11.4px] bg-[#00005506] border-b border-solid border-[#0009321f]">Name</div>
                {dataLoading ? (
                  <div className="flex items-center justify-center relative z-50" style={{ height: 'calc(100vh - 391px)' }}>
                    <div className="simple-spinner-loader">
                      <span></span>
                    </div>
                  </div>
                ) : boardsFetched.length === 0 ? (
                  <div className='w-full mt-5 flex h-[100px] justify-center items-center flex-col gap-y-3'>
                    <ExclamationIcon />
                    <p className='text-[#0000007a] text-[13px]'>No results found</p>
                  </div>
                ) : (
                  <>
                    {boardsFetched?.filter((post) => {
                      if (searchVal === "") {
                        return post;
                      } else if (
                        post?.scorecard_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
                        post?.scorecard_description?.toLowerCase().includes(searchVal.toLowerCase())
                      ) {
                        return post;
                      }
                    })
                      .map((items: any, index: number) => {
                        let findUser =
                          items?.assigned_to &&
                          assignUserList.find((user) => user.id === items.assigned_to);



                        // const findUSer = 
                        //   items?.assigned_to &&
                        //   items?.find((user) => user.id === items.assigned_to);


                        return (
                          <div key={index} className='w-full flex border-b border-[#0009321f] last-of-type:border-none'>
                            <ul className='list-none w-full'>
                            <li className='flex flex-row items-center justify-between text-[0.875rem] px-[11.4px] py-[11.4px] w-full'>
                                <div className='flex shrink-0 pr-0' onClick={() => handleTeamsData(items?.id)}>
                                  <span
                                    className="flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-full border-none text-[14px] font-semibold text-white capitalize"
                                    style={{ backgroundColor: items?.scorecard_colour }}
                                  >
                                    {items.scorecard_name[0]}
                                  </span>
                                </div>
                                <div className='flex-1 px-4'>
                                  <div className='flex justify-start items-center gap-x-2'>
                                    <p className='text-[0.8125rem] font-semibold leading-5 text-[#1b1b1b] capitalize' onClick={() => handleTeamsData(items?.id)}>{items.scorecard_name}</p>
                                    {
                                      items.ai_check === 'yes' &&
                                      <span onClick={() => handleTeamsData(items?.id)} className="inline-flex capitalize items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                                        ai assist
                                      </span>
                                    }
                                    {/* <UserAssignmentDropdown
                                      assignUserList={assignUserList}
                                      onUserSelect={(user) => handleAssignSelect(user, items.id)}
                                      currentlyAssignedUser={findUser?.name}
                                    /> */}
                                    
                                  </div>
                                  <p className='flex text-xs text-[12px] leading-4 text-[#5c5c5e]'>{items?.scorecard_description}</p>
                                </div>
                                <div>
                                  <Badge status={items?.status} />


                                </div>
                                <div className='px-2 flex items-center'>
                                  <Menu as="div" className="relative inline-block text-left">
                                    <div>
                                      <MenuButton className="rounded-md flex items-center justify-center hover:bg-light-gray-200 focus:bg-light-gray-200 w-[32px] h-[32px]">
                                        <span className="sr-only">Open options</span>
                                        <ThreeDotIcon />
                                      </MenuButton>
                                    </div>

                                    <Transition
                                      enter="transition ease-out duration-100"
                                      enterFrom="transform opacity-0 scale-95"
                                      enterTo="transform opacity-100 scale-100"
                                      leave="transition ease-in duration-75"
                                      leaveFrom="transform opacity-100 scale-100"
                                      leaveTo="transform opacity-0 scale-95"
                                    >
                                      <MenuItems className="absolute z-10 mt-[9px] left-[0px] bg-white max-w-[108px] min-w-[108px] w-full overflow-hidden rounded-lg border border-border
                                 bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 
                                 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2
                                  data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2">
                                        <div className="py-1">
                                          <MenuItem>
                                            {({ focus }) => (
                                              <div
                                                onClick={() => handleEdit(items.id, items.base_id)}
                                                className={classNames(
                                                  focus ? "bg-gray-100 text-gray-900" : "text-gray-700",
                                                  "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0"
                                                )}
                                              >
                                                Edit
                                              </div>
                                            )}
                                          </MenuItem>
                                          <MenuItem>
                                            {({ focus }) => (
                                              <Link
                                                to="#"
                                                className={classNames(
                                                  focus ? "bg-gray-100 text-gray-900" : "text-gray-700",
                                                  "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0"
                                                )}
                                                onClick={() => handleDeleteBoard(items.id, items.base_id)}
                                              >
                                                Delete
                                              </Link>
                                            )}
                                          </MenuItem>
                                          <MenuItem>
                                            {({ focus }) => (
                                              <Link
                                                to="#"
                                                onClick={() => handleArchivedBoard(items.id, items.base_id)}
                                                className={classNames(
                                                  focus ? "bg-gray-100 text-gray-900" : "text-gray-700",
                                                  "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0"
                                                )}
                                              >
                                                Archived
                                              </Link>
                                            )}
                                          </MenuItem>

                                        </div>
                                      </MenuItems>
                                    </Transition>
                                  </Menu>
                                </div>
                              </li>
                            </ul>
                          </div>
                        );
                      })}
                  </>
                )}
                </div>
              </div>

            </div>
          </div>
        </main>
      </div>

      <CreateScoreCard
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        editBoardData={editBoardData}
        baseId={baseId}
        setEditBoardData={setEditBoardData}
      />
    </>
  )
});
export default ScoreCard
